// Channel snapshots can omit historical playback/monitoring data after server
// cache cleanup. Omission is not an explicit content clear or a fresh observation.
export function mergeDeviceSnapshot(previous = {}, incoming = {}, available = true) {
  const state = { ...previous, ...incoming };
  if (incoming.channels) {
    state.channels = { ...incoming.channels };
    if (incoming.channels.native) state.channels.native = { ...incoming.channels.native,
      appVersion: incoming.channels.native.appVersion || previous.channels?.native?.appVersion || null };
  }
  if (state.externalApp && (available === false || state.channels?.native?.connected === false)) {
    state.externalApp = { ...state.externalApp, isStale: true };
  }
  return state;
}
